import { render } from "./RevisionBrowser.vue?vue&type=template&id=0d421888&scoped=true"
import script from "./RevisionBrowser.vue?vue&type=script&lang=js"
export * from "./RevisionBrowser.vue?vue&type=script&lang=js"

import "./RevisionBrowser.vue?vue&type=style&index=0&id=0d421888&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d421888"]])

export default __exports__